import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull';
import WithLegendDot from '../WithLegendDot/WithLegendDot';
import styles from './CustomLegend.module.scss';
/**
 * Renders a legend to be used in recharts graphs using the recharts Legend component
 * with "content" prop.
 */ export default function CustomLegend(props) {
    const { items, testId, gap } = props;
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.root,
        "data-testid": testId,
        style: {
            gap
        },
        children: items.map((param, idx)=>{
            let { label, color } = param;
            return /*#__PURE__*/ _jsx(WithLegendDot, {
                color: color,
                children: /*#__PURE__*/ _jsx(Typography, {
                    as: "span",
                    variant: "paragraph2",
                    skin: "secondary",
                    children: label
                })
            }, idx);
        })
    });
}
